import { slugifyTitleForUtm } from './slugifyLatin'
import { stripDateFromCampaignTitle } from './parseDateFromCampaignTitle'
import resolveCampaignDateKey from './resolveCampaignDateKey'

export const buildCleanCampaignKey = ({
  title = '',
  relatedPromoStartDate = null,
  campaignDate = null,
} = {}) => {
  const values = {
    title,
    related_promo_start_date: relatedPromoStartDate,
    campaign_date: campaignDate,
  }
  const strippedTitle = stripDateFromCampaignTitle(title)
  const titleSlug = slugifyTitleForUtm(strippedTitle)

  if (!titleSlug) {
    return ''
  }

  const { dateKey } = resolveCampaignDateKey(values)

  if (dateKey) {
    return `${titleSlug}_${dateKey}`
  }

  return titleSlug
}

export default buildCleanCampaignKey
